import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayout } from './layouts/admin-layout/admin-layout';
import { Dashboard } from './pages/dashboard/dashboard';
import { Login } from './pages/auth/login/login';
import { authGuard } from './guards/auth-guard';
import { superAdminGuard } from './guards/super-admin-guard';
import { Organizations } from './pages/organizations/organizations';
import { OrganizationDetails } from './pages/organization-details/organization-details';
import { ValidationLogs } from './pages/validation-logs/validation-logs';
import { AuditLogs } from './pages/audit-logs/audit-logs';
import { AdminUsers } from './pages/admin-users/admin-users';
import { Settings } from './pages/settings/settings';
import { PasswordResetRequests } from './pages/password-reset-requests/password-reset-requests';
import { Profile } from './pages/profile/profile';

const routes: Routes = [
  { path: 'auth/login', component: Login },
  {
    path: '',
    component: AdminLayout,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: Dashboard },
      { path: 'organizations', component: Organizations },
      { path: 'organizations/:id', component: OrganizationDetails },
      { path: 'validation-logs', component: ValidationLogs },
      { path: 'audit-logs', component: AuditLogs },
      { path: 'admin-users', component: AdminUsers, canActivate: [superAdminGuard] },
      { path: 'settings', component: Settings },
      { path: 'password-reset-requests', component: PasswordResetRequests },
      { path: 'profile', component: Profile },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
